import React, { Component } from 'react';

import { Card, Icon } from 'antd';
import { observer, inject } from 'mobx-react';

import SummaryBadge from './SummaryBadge';
import DtcIcon from '../../../../common/icons/DtcIcon';
import AirIcon from '../../../../common/icons/AirIcon';
import SafetyIcon from '../../../../common/icons/Safety';
import CrashIcon from '../../../../common/icons/CrashIcon';

import './LeadsSummary.css';

@inject('translationsStore', 'filterStore', 'leadsStore')
@observer
class LeadsSummary extends Component {
  toggleFilter = name => () => {
    const { filterStore, leadsStore } = this.props;
    filterStore.add(`summary.${name}`, leadsStore[`${name}FilterFn`], true);
    setTimeout(() => {
      //setTimeout in order to show the toggle before rendering
      filterStore.apply();
    }, 10);
  };

  isFilterSelected = name => !!this.props.filterStore.filters[`summary.${name}`];

  render() {
    const { translationsStore, loading, leadsStore } = this.props;
    return (
      <div className="LeadsSummary" style={{ ...this.props.style, display: 'flex', justifyContent: 'space-between' }}>
        <Card headStyle={{ padding: '0' }} bordered={false} className="malfunctionsCard">
          {!loading && (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <SummaryBadge
                  icon={<DtcIcon />}
                  onClick={this.toggleFilter('withHelpRequests')}
                  selected={this.isFilterSelected('withHelpRequests')}
                  color="#45ba12"
                  count={leadsStore.filterLength('summary', 'withHelpRequests')}
                  label={translationsStore.translate('lead.summary.action')}
                />
                <SummaryBadge
                  icon={<SafetyIcon style={{ fontSize: '17px' }} />}
                  onClick={this.toggleFilter('withAlarmsAndSafety')}
                  selected={this.isFilterSelected('withAlarmsAndSafety')}
                  color="#8727dc"
                  count={leadsStore.filterLength('summary', 'withAlarmsAndSafety')}
                  label={translationsStore.translate('lead.summary.alarms')}
                />
                <SummaryBadge
                  icon={<AirIcon type="battery-warning" />}
                  onClick={this.toggleFilter('withLowBattery')}
                  selected={this.isFilterSelected('withLowBattery')}
                  color="#888888"
                  count={leadsStore.filterLength('summary', 'withLowBattery')}
                  label={translationsStore.translate('lead.summary.lowBattery')}
                />
                 <SummaryBadge
                  icon={<DtcIcon />}
                  onClick={this.toggleFilter('withDtcsRedPlusOrange')}
                  selected={this.isFilterSelected('withDtcsRedPlusOrange')}
                  color="#d0011b"
                  count={leadsStore.filterLength('summary', 'withDtcsRedPlusOrange')}
                  label={translationsStore.translate('lead.summary.dtcs')}
                />

                <SummaryBadge
                  icon={<AirIcon type="tagliando" />}
                  onClick={this.toggleFilter('withMaintenances')}
                  selected={this.isFilterSelected('withMaintenances')}
                  color="#538fea"
                  count={leadsStore.filterLength('summary', 'withMaintenances')}
                  label={translationsStore.translate('lead.summary.maintenance')}
                />
                <SummaryBadge
                  icon={<CrashIcon />}
                  onClick={this.toggleFilter('withCrash')}
                  selected={this.isFilterSelected('withCrash')}
                  color="#538fea"
                  count={leadsStore.filterLength('summary', 'withCrash')}
                  label={translationsStore.translate('lead.summary.crashes')}
                />
              </div>
            </div>
          )}
          {loading && <div className="ant-card-loading-block" style={{ minHeight: '100px', height: '100%' }} />}
        </Card>
      </div>
    );
  }
}

export default LeadsSummary;
